package at.apa.statistictracker.data.remote

sealed class StatisticTrackerApiException: Exception() {
    object NotFound:  StatisticTrackerApiException()
    object Forbidden:  StatisticTrackerApiException()
    class ValidationError(message: String): StatisticTrackerApiException()
    class GeneralError(message: String): StatisticTrackerApiException()
}